import { DateRangeType } from '../types/phlebotomist-dashboard';

/**
 * Get a display-friendly label for a date range type.
 *
 * @param dateRange - The date range type to get a label for
 * @returns Human-readable label for the date range
 */
export function getDateRangeDisplayLabel(dateRange: DateRangeType): string {
  const labels: Record<DateRangeType, string> = {
    // Rolling periods
    day: 'Today',
    yesterday: 'Yesterday',
    week: 'Week',
    lastWeek: 'Last Week',
    month: 'Month',
    lastMonth: 'Last Month',
    quarter: 'Quarter',
    lastQuarter: 'Last Quarter',
    year: 'Year',
    lastYear: 'Last Year',
    // Calendar periods
    dayCal: 'Today',
    yesterdayCal: 'Yesterday',
    weekCal: 'This Week',
    lastWeekCal: 'Last Week',
    monthCal: 'This Month',
    lastMonthCal: 'Last Month',
    quarterCal: 'This Quarter',
    lastQuarterCal: 'Last Quarter',
    yearCal: 'This Year',
    pYearCal: 'Last Year',
    // Custom
    custom: 'Custom',
  };

  return labels[dateRange] || dateRange;
}
